module.exports = __webpack_public_path__ + "static/lala-c0ebcf72f8618510283262f2d09e6e2f.jpg";